var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 394.188,
    height: 344.988,
    viewBox: "0 0 394.188 344.988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contact",
    transform: "translate(0.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M281.608,324.812,262.6,314.107a70.383,70.383,0,0,1,7.409-33.044c4.382,19.889,27.443,29.352,38.083,46.717a42.336,42.336,0,0,1,3.437,36.534l1.25,15.421a70.941,70.941,0,0,1-44.54-39.3,68.528,68.528,0,0,1-4.754-16.52C272.349,324.858,281.608,324.812,281.608,324.812Z",
    transform: "translate(-262.591 -207.25)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M864.647,676.484l.583-13.1a42.325,42.325,0,0,1,19.741-5c-9.482,7.752-8.3,22.694-14.725,33.118a25.458,25.458,0,0,1-18.668,11.764l-7.934,4.858a42.659,42.659,0,0,1,8.991-34.568,41.207,41.207,0,0,1,7.573-7.037C862.109,671.528,864.647,676.484,864.647,676.484Z",
    transform: "translate(-503.956 -364.165)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M574.941,557.56h-7.185l-3.418-27.711h10.6Z",
    transform: "translate(-234.692 -220.346)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M831.724,735H808.558V734.7a9.017,9.017,0,0,1,9.016-9.017h0l4.231-3.21,7.9,3.211h2.022Z",
    transform: "translate(-489.643 -390.82)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M517.8,557.56h-7.184L507.2,529.848h10.6Z",
    transform: "translate(-210.93 -220.346)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M774.583,735H751.418V734.7a9.017,9.017,0,0,1,9.016-9.017h0l4.232-3.21,7.9,3.211h2.022Z",
    transform: "translate(-465.881 -390.82)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M774.316,472.631l46.731,1.168c8.875,4.821,9.01,15.254,6.1,27.641,0,0,.982,7.363-.982,9.326s-2.945,1.963-1.963,5.4-4.205,9.048-3.575,9.678a25.4,25.4,0,0,1,2.1,4.066l-4.909,27.978s-3.436,48.594-4.418,49.576-1.963,0-.982,2.454,1.963,1.473.982,2.454a36.122,36.122,0,0,0-2.454,2.945H799.083s-.895-4.909-.895-5.4-.982-3.436-.982-3.927.868-1.358.868-1.358a16.149,16.149,0,0,0,.6-3.059c0-.982,2.945-38.777,2.945-38.777l-5.89-49.085-14.235,48.1s0,42.213-.982,43.194-.982.491-.491,2.454,2.454,1.473.982,2.945-1.963-.982-1.473,1.473l.491,2.454-14.725.211s-1.963-4.137-.982-5.61.923-1.071-.275-3.48-1.689-2.9-1.2-3.392.491-3.1.491-3.1L765.793,552s.491-49.576.491-51.048a4.9,4.9,0,0,0-.408-2.208v-2l1.88-7.083Z",
    transform: "translate(-470.556 -286.917)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 14.519,
    cy: 14.519,
    r: 14.519,
    transform: "translate(317.313 59.505)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M800.571,317.688c-3.128,1.86-5,5.276-6.073,8.753a82.945,82.945,0,0,0-3.565,19.819L789.8,366.4l-14.051,42.88c12.178,10.3,57.951,2.342,57.951,2.342s1.405-.468,0-1.874-2.773-.16-1.368-1.565.436.16-.032-1.245,0-.468.468-.937-3.626-4.684-3.626-4.684l3.747-24.614,4.684-49.647c-5.62-7.026-16.924-11.167-16.924-11.167l-2.921-5.257-14.6,1.168Z",
    transform: "translate(-475.999 -219.547)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M811.1,258.225a6.863,6.863,0,0,1,1.665.218,23.7,23.7,0,0,0,3.259.546A15.1,15.1,0,0,1,829.55,271.8c.844-.736,2.764-2.089,4.337-.831h0c.024.02.038.03.093,0,1.045-.5,2.9-6.6,2.956-11.97.03-2.852-.419-6.493-2.725-7.646l-.122-.061-.032-.132c-.154-.641-1.876-1.736-4.868-2.589-5.437-1.549-13.543-4.566-18.107-.126-.345,1.5-1.469,4.7-2.6,5.063-1.257.4-2.343.749-2.514,2.291A47.246,47.246,0,0,0,806,262.39a6.729,6.729,0,0,1,2.39-3.358A4.738,4.738,0,0,1,811.1,258.225Z",
    transform: "translate(-488.524 -192.721)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M733.895,382.063l23.718-15.189-11.946-15.88-11.8,14.51-36.753,2.254a7,7,0,1,0-.392,10.322Z",
    transform: "translate(-438.338 -236.332)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M813.283,334.173c1.377,8.331-24.619,24.239-24.619,24.239,0-1.955-15.516,12.806-16.216,11.185-1.99-4.609-3.39-15.526-6.171-17.273-1.591-1,9.579-10.386,9.579-10.386s5.847-5.89,13.52-13.32a17.9,17.9,0,0,1,16.579-4.846S811.907,325.842,813.283,334.173Z",
    transform: "translate(-471.996 -224.833)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M908.256,394.355l-15.688-23.391-15.623,12.279L891.7,394.73l3.032,36.7a7,7,0,1,0,10.328.173Z",
    transform: "translate(-518.083 -244.638)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M859.063,334.008c8.3-1.553,24.755,24.1,24.755,24.1-1.955.042,13.132,15.241,11.525,15.976-4.566,2.088-15.45,3.718-17.138,6.535-.965,1.611-10.587-9.357-10.587-9.357s-6.013-5.721-13.6-13.235a17.9,17.9,0,0,1-5.2-16.473S850.763,335.56,859.063,334.008Z",
    transform: "translate(-506.241 -229.24)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M819.856,743.614a.693.693,0,0,1-.7.7H655.434a.7.7,0,0,1,0-1.39H819.161a.693.693,0,0,1,.7.7Z",
    transform: "translate(-425.675 -399.321)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M527.951,383.493h-198.7A11.723,11.723,0,0,0,317.537,395.2V518.915a11.723,11.723,0,0,0,11.709,11.709h198.7a11.723,11.723,0,0,0,11.709-11.709V395.2A11.723,11.723,0,0,0,527.951,383.493Z",
    transform: "translate(-285.444 -249.848)",
    fill: "#16c389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M527.951,383.493h-198.7A11.723,11.723,0,0,0,317.537,395.2V518.915a11.723,11.723,0,0,0,11.709,11.709h198.7a11.723,11.723,0,0,0,11.709-11.709V395.2A11.723,11.723,0,0,0,527.951,383.493Zm3.843,88.864a48.136,48.136,0,0,1-47.325,47.948c-20.162.262,11.155.365-13.162.365-55.605,0-113.586-.531-135.219-.876A10.909,10.909,0,0,1,325.4,508.93V395.211a3.856,3.856,0,0,1,3.842-3.851h198.7a3.855,3.855,0,0,1,3.851,3.841Z",
    transform: "translate(-285.444 -249.848)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M506.827,261.538H355.435a6.507,6.507,0,0,0-6.116,4.313l-23.381,65.6a6.494,6.494,0,0,0,6.107,8.674l203.042.36h.009a6.493,6.493,0,0,0,5.968-9.051l-.354.152.354-.152L512.8,265.473A6.486,6.486,0,0,0,506.827,261.538Z",
    transform: "translate(-288.781 -199.131)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M541.589,379.007a6.51,6.51,0,0,1-.526,2.559L512.8,432.338a6.511,6.511,0,0,1-5.97,3.931H355.438a6.511,6.511,0,0,1-6.122-4.311l-23.377-50.411a6.489,6.489,0,0,1,3.937-8.295,6.389,6.389,0,0,1,2.167-.38l24.8-.047,10.123-.018,133.206-.234,10.129-.018,24.785-.047h.006a6.5,6.5,0,0,1,6.5,6.494Z",
    transform: "translate(-288.781 -245.281)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M359.214,542.358c3,0,44.227,2.52,44.227,5.522s-41.225,5.35-44.227,5.35a5.436,5.436,0,1,1,0-10.871Z",
    transform: "translate(-300.516 -315.914)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M519.673,193.221H392.022a12.918,12.918,0,0,0-12.9,12.9V361.708H529.1a6.413,6.413,0,0,0,3.476-1.011V206.125a12.918,12.918,0,0,0-12.9-12.9Z",
    transform: "translate(-311.054 -170.72)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M478.158,211.131H408.2a11.764,11.764,0,0,0-11.753,11.747V369.157H529.655V262.628a51.557,51.557,0,0,0-51.5-51.5Z",
    transform: "translate(-318.261 -178.168)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M521.08,459.421H433.261a2.862,2.862,0,0,0,0,5.724H521.08a2.862,2.862,0,0,0,0-5.724Z",
    transform: "translate(-332.38 -281.424)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M521.078,440.041H433.259a2.865,2.865,0,1,0,0,5.73h87.819a2.865,2.865,0,0,0,0-5.73Z",
    transform: "translate(-332.378 -273.364)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M471.328,420.671H433.26a2.862,2.862,0,0,0,0,5.724h38.068a2.862,2.862,0,0,0,0-5.724Z",
    transform: "translate(-332.379 -265.309)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M521.078,380.091H433.259a2.865,2.865,0,0,0,0,5.73h87.819a2.865,2.865,0,0,0,0-5.73Z",
    transform: "translate(-332.378 -248.433)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M521.08,360.721H433.261a2.862,2.862,0,0,0,0,5.725H521.08a2.862,2.862,0,0,0,0-5.725Z",
    transform: "translate(-332.38 -240.378)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M471.326,341.341H433.258a2.865,2.865,0,1,0,0,5.73h38.068a2.865,2.865,0,0,0,0-5.73Z",
    transform: "translate(-332.377 -232.318)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M521.078,300.761H433.259a2.865,2.865,0,0,0,0,5.73h87.819a2.865,2.865,0,0,0,0-5.73Z",
    transform: "translate(-332.378 -215.442)",
    fill: "#16c389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M521.078,281.391H433.259a2.865,2.865,0,0,0,0,5.73h87.819a2.865,2.865,0,0,0,0-5.73Z",
    transform: "translate(-332.378 -207.387)",
    fill: "#16c389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M471.326,262.011H433.258a2.865,2.865,0,1,0,0,5.73h38.068a2.865,2.865,0,0,0,0-5.73Z",
    transform: "translate(-332.377 -199.327)",
    fill: "#16c389"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 22.292,
    cy: 22.292,
    r: 22.292,
    transform: "translate(194.445 0)",
    fill: "#16c389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M622.335,196.2a2.479,2.479,0,0,1-1.984-.992L614.27,187.1a2.48,2.48,0,0,1,3.968-2.975l3.979,5.3L632.435,174.1a2.48,2.48,0,0,1,4.127,2.751L624.4,195.1a2.481,2.481,0,0,1-1.995,1.1Z",
    transform: "translate(-408.639 -162.311)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.e945c362f27e300f68fe555ef7543c76.svg";
export { ForwardRef as ReactComponent };